import AkStockRelationDataTable from './AkStockRelationDataTable.vue';

export default {
    name: 'ak-stock-relation-resolver',
    functional: true,
    props: {
        relationString: {
            type: String,
            required: true,
        },
        relationReference: {
            type: String,
            default: '',
        },
        enableForeignList: {
            type: Boolean,
            default: false,
        },
        defaultIdsSelected: {
            type: Array,
            default: () => [],
        },
        filterOrderId: {
            type: String,
            default: null,
        },
    },
    render(createElement, context) {
        const relation = context.props.relationString.split(':');
        const currentType = relation.shift();
        const currentBundle = relation.shift();
        const currentDefinition = relation.shift();

        if (currentType === 'grid' || currentType === 'list') {
            const childRelationString = relation.length ? relation.join(':') : undefined;

            return createElement('ak-stacked-window', {
                props: {
                    showClose: false,
                },
                on: {
                    close: context.listeners.close,
                },
                scopedSlots: {
                    default: childProps => createElement(AkStockRelationDataTable, {
                        props: {
                            type: currentType,
                            bundle: currentBundle,
                            definition: currentDefinition,
                            relation: context.props.relationReference,
                            defaultIdsSelected: context.props.defaultIdsSelected,
                            childRelationString,
                            filterOrderId: context.props.filterOrderId,
                        },
                        on: {
                            save: context.listeners.updateRelations,
                            close: childProps.close,
                            refresh: context.listeners.updateRelations,
                        },
                    }),
                },
            });
        }

        if (currentType === 'form') {
            const currentObjectId = relation.shift();
            const childRelationString = relation.length ? relation.join(':') : undefined;

            return createElement('ak-stacked-window', {
                props: {
                    showClose: false,
                    resizable: true,
                    minWidth: null,
                },
                on: {
                    close: context.listeners.close,
                },
                scopedSlots: {
                    default: childProps => createElement('ak-form', {
                        props: {
                            bundle: currentBundle,
                            definition: currentDefinition,
                            objectId: currentObjectId,
                            relationString: childRelationString,
                        },
                        on: {
                            save: childProps.close,
                            cancel: childProps.close,
                            saveDataObject: data => context.listeners.refresh([data.dataObjectId]),
                        },
                    }),
                },
            });
        }

        return null;
    },
};
